import { BaseListFilter } from '../../../models/base-list-filter.model';
import { ReportUserStatusEnum } from './report-user-status.enum';

export class ReportUsersFilter extends BaseListFilter {
  search?: string;
  searchByName?: string;
  searchByEmail?: string;
  status? = ReportUserStatusEnum.Active;
  brokerId?: number;
}
